const Arrow = ({className}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 16">
    <g>
      <path d="M 0,8 24,0 48,8 48,16 H 0 Z" />
    </g>
  </svg>
)

export default Arrow
